<template>

<div class="container mt-4">
  <sym-card class="beige fw-76 mx-auto" bodyClass="p-2">
    <h6 slot="header">Device Info</h6>
    <ul class='mb-1 p-0'>
      <li class="list-item">Width
        <span class="float-right">{{ width }}</span>
      </li>
      <li class="list-item">Height
        <span class="float-right">{{ height }}</span>
      </li>
      <li class="list-item">Available Width
        <span class="float-right">{{ availWidth }}</span>
      </li>
      <li class="list-item">Available Height
        <span class="float-right">{{ availHeight }}</span>
      </li>
      <li class="list-item">Pixel Depth
        <span class="float-right">{{ pixelDepth }}</span>
      </li>
      <li class="list-item">Platform
        <span class="float-right">{{ platform }}</span>
      </li>
      <li class="list-item">Orientation
        <span class="float-right">{{ orientation }}</span>
      </li>
    </ul>
  </sym-card>
</div>

</template>

<script>

// import PageBase from '../PageBase.vue';

export default {
  // extends: PageBase,
  name: 'samples-device-info',

  computed: {
    orientation () {
      const s = window.screen;
      if (s.orientation) {
        return s.orientation.type;
      }
      return s.msOrientation || '';
    }
  },

  created () {
    this.width = window.screen.width;
    this.height = window.screen.height;
    this.availWidth = window.screen.availWidth;
    this.availHeight = window.screen.availHeight;
    this.pixelDepth = window.screen.pixelDepth;
    this.platform = navigator.platform;
  }

}

</script>
